"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PhoneSupportDesktop = void 0;
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const atome_1 = require("../../../components/atome");
const GlobalStyles_1 = require("../../../helper/GlobalStyles");
const Dashboard_web_style_1 = require("./Dashboard.web.style");
const PhoneSupportDesktop = (props) => {
    const { navigateTo } = props;
    return (react_1.default.createElement(react_native_1.View, { style: [GlobalStyles_1.globalStyles.row, Dashboard_web_style_1.styles.helpContainer] },
        react_1.default.createElement(atome_1.Icon, { icon: "social" }),
        react_1.default.createElement(react_native_1.View, { style: [GlobalStyles_1.globalStyles.flex2, GlobalStyles_1.globalStyles.marginLeft15] },
            react_1.default.createElement(atome_1.Text, { style: [Dashboard_web_style_1.styles.containerHeader] }, "Wir unterst\u00FCtzen Sie!"),
            react_1.default.createElement(atome_1.Text, { style: [Dashboard_web_style_1.styles.containerText] }, "Falls Sie Fragen haben oder unsicher sind, stehen wir Ihnen telefonisch pers\u00F6nlich unter 032 221 857 962 zur Verf\u00FCgung."))));
};
exports.PhoneSupportDesktop = PhoneSupportDesktop;
